import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminLocationsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('location');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
